module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    attrs: {
      "inline": true,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "AGL"
    }
  }, [_c('el-input-number', {
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "AGL",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.agl),
      callback: function($$v) {
        _vm.$set(_vm.equip, "agl", $$v)
      },
      expression: "equip.agl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Height On Tower"
    }
  }, [_c('el-input-number', {
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Height on Tower",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.heightOnTower),
      callback: function($$v) {
        _vm.$set(_vm.equip, "heightOnTower", $$v)
      },
      expression: "equip.heightOnTower"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sector"
    }
  }, [_c('el-input-number', {
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Sector",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.sector),
      callback: function($$v) {
        _vm.$set(_vm.equip, "sector", $$v)
      },
      expression: "equip.sector"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Level"
    }
  }, [_c('el-input-number', {
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Level",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.level),
      callback: function($$v) {
        _vm.$set(_vm.equip, "level", $$v)
      },
      expression: "equip.level"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10ce1aeb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/features/OnTower.vue
// module id = 1427
// module chunks = 0